import {useAuthStore} from "@/stores";

export function isSelf(user: any) {
    const authStore = useAuthStore();
    const appUser: any = authStore.user;
    return appUser.id === user.id;
}

export default (): any => useAuthStore().user;
